import React from 'react';
import './About.css';

const About = () => {
    return (
        <div className="about-page">
            <section className="about-hero">
                <div className="about-title-box">
                    <span className="gold-tag">Our Legacy</span>
                    <h1>Built on Integrity.</h1>
                </div>
            </section>

            <section className="about-content">
                <div className="about-grid">
                    <div className="about-text">
                        <h2>The Architectural Approach</h2>
                        <p>
                            At the core of every successful business is a structure that can withstand 
                            the pressure of growth. The Pillar was conceived as a response to the 
                            temporary nature of modern web design.
                        </p>
                        <p>
                            We don't just build pages; we design digital landmarks. By focusing on 
                            order, symmetry, and high-quality materials - even in code - we ensure your 
                            corporate presence remains as permanent as a monument.
                        </p>
                    </div>

                    <div className="about-values">
                        <div className="value-item">
                            <h4>Precision</h4>
                            <p>Every pixel is aligned to a grid system that ensures perfect balance.</p>
                        </div>
                        <div className="value-item">
                            <h4>Longevity</h4>
                            <p>Our code is written to be scalable, supporting your business for years to come.</p>
                        </div>
                        <div className="value-item">
                            <h4>Authority</h4>
                            <p>We use visual cues that command respect and establish market leadership.</p>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default About;